import { render } from "./ContactsTab.vue?vue&type=template&id=5de6cee2"
import script from "./ContactsTab.vue?vue&type=script&lang=js"
export * from "./ContactsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__